import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import MenuPersonasSSV from './MenuPersonasSSV';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useForm } from 'react-hook-form';
import { Card, CardHeader, CardBody, CardFooter, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import { FaSave, FaArrowAltCircleRight } from 'react-icons/fa';
import moment from 'moment';
function CalcularEdad(date){
            return moment().diff(date, 'years');
        }
export default function SSVEducacion() {
    const { token } = useAuth();
    const { idEncuesta, idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [edad, setEdad] = useState('');
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const fetchData = async (idPersona, idEncuesta) => {
            let url = `/encuestassv/educacion/crearformularioeducacion`;
            let obj = { idPersona: idPersona, idEncuesta: idEncuesta };
            await apiService.post(url, obj, token)
            .then(response => {
                const result = response.data;
    
                resetForm(result.datosEducacion);
                console.log('Datos de educación obtenidos:', result);
            })
            .catch(error => {
                if (error.response.data.message) {
                    Mensaje('Error', error.response.data.message);
                } else {
                    Mensaje('Error', 'No se pudieron obtener los datos de educación de la persona.');
                }
            })
            .finally(() => {
                setCargando(false);
            });
        };
      
        useEffect(() => {
            fetchData(idPersona, idEncuesta);
        }, [idPersona, idEncuesta]);    

    async function GuardarDatosEducacion() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/educacion/guardardatoseducacion`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de educación de la persona.');
            }
        })
        .catch(error => {
            if (error?.response?.data?.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de educación de la persona. ' + (error.message || ''));
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }

    const resetForm = (data) => {
        try {
            if (data) {
                reset((prevValues) => ({
                    ...prevValues,
                    id: data.id || '',
                    cons_ficha_id: data.cons_ficha_id || '',
                    nombre: data.nombre || '',
                    id_ficha: data.id_ficha || '',
                    educacion_sabe_leer_escribir: data.educacion_sabe_leer_escribir || '',
                    educacion_esta_matriculado: data.educacion_esta_matriculado || '',
                    educacion_past_year_esta_matriculado: data.educacion_past_year_esta_matriculado || '',
                    educacion_past_year_finalizado: data.educacion_past_year_finalizado || '',
                    educacion_nivel_educativo: data.educacion_nivel_educativo || '',
                    educacion_ultimo_grado_aprobado: data.educacion_ultimo_grado_aprobado || '',
                    educacion_cual_tec_uni: data.educacion_cual_tec_uni || '',
                    educacion_razon_no_estudiar: data.educacion_razon_no_estudiar || '',
                    educacion_razon_no_estudiar_cual: data.educacion_razon_no_estudiar_cual || '',
                    educacion_interes_en_formacion: data.educacion_interes_en_formacion || '',
                    educacion_interes_en_formacion_cual: data.educacion_interes_en_formacion_cual || '',
                }))
                setEdad(CalcularEdad(data.datos_basicos_fecha_nacimiento));
            }
        } catch (error) {
            console.error('Error al resetear el formulario:', error);
        }
        
    }
  
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Personas Educaci&oacute;n</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Educaci&oacute;n</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuPersonasSSV idEncuesta={idEncuesta} idPersona={idPersona}></MenuPersonasSSV>
                    <hr />
                    <Form onSubmit={handleSubmit(GuardarDatosEducacion)}>
                        <Card>
                            <CardHeader>
                                <h2>Para cada integrante de la familia</h2>
                                <b>Aplica para todas las personas del hogar. Para menores de 15 años, contesta el informante idoneo.</b>
                            </CardHeader>
                            <CardBody>
                                
                                <Row>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="id">id</Form.Label>
                                        <Form.Control readOnly id="id" placeholder="id" type="text" {...register("id")} />
                                        </FormGroup>  
                                    </Col>
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label htmlFor="nombre">Nombre de la persona</Form.Label>
                                        <Form.Control readOnly id="nombre" placeholder="Nombre" type="text" {...register("nombre")} />
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="edad_calculada">Edad</Form.Label>
                                        <Form.Control readOnly id="edad_calculada" placeholder="Edad" type="text" value={edad}/>
                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label >1. ¿Sabe leer y escribir?</Form.Label>
                                        <Form.Control as="select" id="educacion_sabe_leer_escribir" style={{width: "100%"}} aria-hidden="true" {...register("educacion_sabe_leer_escribir")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        <p>Aplica solo para mayores de 7 años de edad</p>
                                        {errors.educacion_sabe_leer_escribir && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    <div className="dersuperado" hidden>
                                        <button id="educacionseguimiento" type="button" className="btn btn-primary btn-xs" data-toggle="modal" data-target="#modal-seguimientoderecho">
                                        Superación del derecho
                                        </button>
                                    </div>
                                    </Col>
                                    
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label>2. ¿Actualmente (El año en curso)… está matriculado(a) en alguna institución educativa formal?(preescolar, escuela, colegio o universidad)(pública o privada)</Form.Label>
                                        <Form.Control as="select" id="educacion_esta_matriculado" style={{width: "100%"}} aria-hidden="true" {...register("educacion_esta_matriculado")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        {errors.educacion_esta_matriculado && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={4}>
                                    <FormGroup>
                                        <Form.Label>3. ¿El año inmediatamente anterior… estuvo matriculado(a) en alguna institución educativa formal?(preescolar, escuela, colegio o universidad)(pública o privada)</Form.Label>
                                        <Form.Control as="select" id="educacion_past_year_esta_matriculado" style={{width: "100%"}} aria-hidden="true" {...register("educacion_past_year_esta_matriculado")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No (Pase a la pregunta 5)</option>
                                        </Form.Control>
                                        {errors.educacion_past_year_esta_matriculado && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label>4. ¿Terminó el año escolar inmediatamente anterior?</Form.Label>
                                        <Form.Control as="select" id="educacion_past_year_finalizado" style={{width: "100%"}} aria-hidden="true" {...register("educacion_past_year_finalizado")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        {errors.educacion_past_year_finalizado && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label> 5. ¿Cuál es el nivel educativo más alto alcanzado y el último grado o semestre aprobado en ese nivel?</Form.Label>
                                        <Form.Control as="select" id="educacion_nivel_educativo" style={{width: "100%"}} aria-hidden="true" {...register("educacion_nivel_educativo")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Ninguno</option>
                                        <option value="2">2. Preescolar o centro de desarrollo infantil</option>
                                        <option value="3">3. Básica primaria (1.o - 5.o)</option>
                                        <option value="4">4. Básica secundaria (6.o - 9.o)</option>
                                        <option value="5">5. Media (10.o - 13.o)</option>
                                        <option value="6">6. Técnica o tecnológica</option>
                                        <option value="7">7. Superior o universitaria</option>
                                        <option value="98">98. No sabe / no informa</option>
                                        </Form.Control>
                                        {errors.educacion_nivel_educativo && <span className="text-danger">Este campo es requerido</span>}
                                        <Form.Control id="educacion_cual_tec_uni" placeholder="cual" type="text" {...register("educacion_cual_tec_uni")} />
                                        {errors.educacion_cual_tec_uni && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label htmlFor="educacion_ultimo_grado_aprobado">Y el último año, grado, nivel o semestre aprobado</Form.Label>
                                        <Form.Control id="educacion_ultimo_grado_aprobado" placeholder="cual" type="text" {...register("educacion_ultimo_grado_aprobado")} />
                                        {errors.educacion_ultimo_grado_aprobado && <span className="text-danger">Este campo es requerido</span>}
                                        </FormGroup>  
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <div className="box-header with-border">
                                    <h3 className="box-title">Aplica solo para las personas que no están estudiando</h3>
                                    </div>
                                </Row>
                                    
                                <Row>
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label> 6. Actualmente, ¿Cuál es la razón principal por la que … no asiste a la escuela, colegio o universidad?</Form.Label>
                                        <Form.Control as="select" id="educacion_razon_no_estudiar" style={{width: "100%"}} aria-hidden="true" {...register("educacion_razon_no_estudiar")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Tiene que trabajar o buscar trabajo</option>
                                        <option value="2">2. No tiene dinero para sus estudios</option>
                                        <option value="3">3. No hay cupo / no hay centro educativo cercano/ cambio de residencia</option>
                                        <option value="4">4. Debe encargarse de los oficios del hogar / debe encargarse del cuidado de los hijos, adultos mayores, enfermos, otras personas</option>
                                        <option value="5">5. Por embarazo</option>
                                        <option value="6">6. Problemas de seguridad (presencia de pandillas,grupos armados ilegales) / problemas de abuso (matoneo)/por desplazamiento forzado</option>
                                        <option value="7">7. No tiene acceso a la educación especial que necesita (discapacidad, etnoeducación)</option>
                                        <option value="8">8. Ya no interesa, no le gusta, no quiere</option>
                                        <option value="9">9. Otra, ¿Cuál?</option>
                                        </Form.Control>
                                        {errors.educacion_razon_no_estudiar && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                    
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label htmlFor="educacion_razon_no_estudiar_cual">6.a. Otra, Cual?</Form.Label>
                                        <Form.Control id="educacion_razon_no_estudiar_cual" placeholder="Cual" type="text" {...register("educacion_razon_no_estudiar_cual")} />
                                        {errors.educacion_razon_no_estudiar_cual && <span className="text-danger">Este campo es requerido</span>}
                                        </FormGroup>  
                                    </Col>
                                
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label>7. ¿Quién no estudia expresa interes en algún proceso de formación ?</Form.Label>
                                        <Form.Control as="select" id="educacion_interes_en_formacion" style={{width: "100%"}} aria-hidden="true" {...register("educacion_interes_en_formacion")} >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si, educacion básica primaria, básica secundaria o media</option>
                                        <option value="2">2. Si, educación técnica o tecnológica</option>
                                        <option value="3">3. Si, educación superior</option>
                                        <option value="4">4. Si, cursos en artes u oficios, Cuál?</option>
                                        <option value="5">5. No</option>
                                        </Form.Control>
                                        {errors.educacion_interes_en_formacion && <span className="text-danger">Este campo es requerido</span>}
                                        <Form.Control id="educacion_interes_en_formacion_cual" placeholder="Cual" type="text" {...register("educacion_interes_en_formacion_cual")} />
                                        {errors.educacion_interes_en_formacion_cual && <span className="text-danger">Este campo es requerido</span>}
                                    </FormGroup>
                                    </Col>
                                </Row>
                                
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                                    <Button type='submit' id="Guardar" className="btn btn-primary">
                                        <FaSave />
                                        Guardar
                                    </Button>
                                    <Button 
                                        id="Cancelar" 
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            globalThis.location.href = `/encuestassv/id/${idEncuesta}`;
                                        }
                                        }>
                                        <FaArrowAltCircleRight />
                                        Volver
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Form>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }